module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "15px",
      "width": "80%",
      "min-width": "800px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("个人信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idcard"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idcard),
      callback: function($$v) {
        _vm.$set(_vm.form, "idcard", $$v)
      },
      expression: "form.idcard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "addr"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    model: {
      value: (_vm.form.addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "addr", $$v)
      },
      expression: "form.addr"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("立即修改")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61db15d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalinfo/modify.vue
// module id = 1208
// module chunks = 10